import React from "react";

import { Text, textPropTypes } from "../Text";

/** The Strong component renders strong text. */
export const Strong = (props) => <Text bold element="strong" {...props} />;

Strong.displayName = "Strong";

Strong.propTypes = textPropTypes;
